import Rails from '@rails/ujs'

// Guard against a second start(): multiple entry packs can start rails-ujs on one
// page (v1/v2 migration), and rails-ujs throws "already been loaded!" on re-start.
export default function startRailsUjs () {
  if (!window._rails_loaded) {
    Rails.start()
  }
}
